"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolPencilLineIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ToolPencilLineIcon16Light = forwardRef_1.forwardRef('ToolPencilLineIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.354 1.439a1.5 1.5 0 0 1 2.122 0l1.085 1.086a1.5 1.5 0 0 1 0 2.121L4.646 13.56a1.5 1.5 0 0 1-1.06.44H1.5a.5.5 0 0 1-.5-.5v-2.087c0-.397.158-.779.44-1.06l8.914-8.915Zm1.414.707a.5.5 0 0 0-.707 0L9.957 3.25l1.793 1.793 1.104-1.104a.5.5 0 0 0 0-.707l-1.086-1.086Zm-9.622 8.915L9.25 3.957l1.793 1.793-7.104 7.104a.5.5 0 0 1-.353.146H2v-1.586a.5.5 0 0 1 .146-.353Z" }),
        react_1.default.createElement("path", { d: "M7.5 13a.5.5 0 1 0 0 1h7a.5.5 0 0 0 0-1h-7Z" })));
});
